import script from "./CTournamentInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./CTournamentInfo.vue?vue&type=script&setup=true&lang=ts"

import "./CTournamentInfo.vue?vue&type=style&index=0&id=799283d4&lang=less"

const __exports__ = script;

export default __exports__